module.exports = __webpack_public_path__ + "static/media/Actor.d221b2e8.png";